import axios from "axios";

const endpoint_url = "/analytic/api/v1/petworld/credits-reimbursed";

const getCreditsReimbursed = (parameters) => {
  return new Promise((resolve, reject) => {
    axios
      .post(endpoint_url, parameters)
      .then((response) => resolve(response.data))
      .catch((error) => {
        if (error?.response?.data) {
          reject(error.response.data);
        } else {
          reject(error);
        }
      });
  });
};

export default getCreditsReimbursed;
